









































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Customer from '@/models/Customer';
import formatCustomer from '@/utils/formatCustomer';
import moment from 'moment';
import { getCustomersPrescriber , archiveCustomerPrescriber } from '@/api/api';
import MetaDatatable from '@/models/MetaDatatable';
import AuthModule from '@/store/AuthModule';
import { BACKEND_URL } from '@/helpers/constants';
import {
    customerStatusMini,
    formatCustomerStatus,
    customerStatusColors,
} from '@/data/customerStatus';

@Component({
    filters: {
        formatCustomer,
        formatDate(date: string | null | undefined) {
            if (!date) return '-';
            return moment(date).format('DD/MM/YYYY');
        },
        formatCustomerStatus,
    },
})
export default class ProspectsTable extends Vue {
  
        customers: Customer[] = [];
    loading: boolean = false;
    searchQuery: string = '';
    statusFilter: string = '';
    selectedCustomers: number[] = [];
    sortBy: string = 'created_at';
    sortDirection: 'asc' | 'desc' = 'desc';
    currentPage: number = 1;
    perPage: number = 25;


    showDeleteConfirm: boolean = false;
    showBulkDeleteConfirm: boolean = false;
    customerToDelete: Customer | null = null;



    meta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 0,
        perPage: -1,
        search: null,
        orderBy: 'createdAt',
        orderWay: 'desc',
        filters: {
            prescribers: undefined,
            status: undefined,
        },
    };

    get firstname() {
        return AuthModule.firstname;
    }

    get lastname() {
        return AuthModule.lastname;
    }

    get logo() {
        return AuthModule.logo;
    }

    get isSubscribed() {
        return AuthModule.isSubscriptionActive;
    }

    get backendUrl() {
        return BACKEND_URL;
    }

    get totalProspects() {
        return this.customers.length;
    }

    get inProgressCount() {
        return this.customers.filter(c => c.status === 'in_progress').length;
    }

    get processedCount() {
        return this.customers.filter(c => c.status === 'processed').length;
    }

    async created() {
        this.loading = true;
        await this.fetch();
        this.loading = false;
    }

    async fetch() {
        const { data } = await getCustomersPrescriber(this.meta);
        this.customers = data.data;
    }



    get filteredCustomers() {
        let filtered = this.customers;

        if (this.searchQuery) {
            const query = this.searchQuery.toLowerCase();
            filtered = filtered.filter(customer => {
                const name = (formatCustomer(customer) || '').toLowerCase();
                const email = (customer.email || '').toLowerCase();
                const phone = (customer.phone || customer.mobile || '').toLowerCase();
                return name.includes(query) || email.includes(query) || phone.includes(query);
            });
        }

        if (this.statusFilter) {
            filtered = filtered.filter(customer => customer.status === this.statusFilter);
        }

        return this.sortCustomers(filtered);
    }

    get paginatedCustomers() {
        const start = (this.currentPage - 1) * this.perPage;
        const end = start + this.perPage;
        return this.filteredCustomers.slice(start, end);
    }

    get totalPages() {
        return Math.ceil(this.filteredCustomers.length / this.perPage);
    }

    @Watch('perPage')
    onPerPageChange() {
        this.currentPage = 1;
    }

    @Watch('searchQuery')
    onSearchChange() {
        this.currentPage = 1;
    }

    @Watch('statusFilter')
    onStatusChange() {
        this.currentPage = 1;
    }

    sortCustomers(customers: Customer[]) {
        return [...customers].sort((a, b) => {
            let aVal: any;
            let bVal: any;

            switch (this.sortBy) {
                case 'id':
                    aVal = a.id;
                    bVal = b.id;
                    break;
                case 'civility':
                    aVal = formatCustomer(a) || '';
                    bVal = formatCustomer(b) || '';
                    break;
                case 'email':
                    aVal = a.email || '';
                    bVal = b.email || '';
                    break;
                case 'phone':
                    aVal = a.phone || a.mobile || '';
                    bVal = b.phone || b.mobile || '';
                    break;
                case 'address':
                    aVal = a.address ? a.address.city : '';
                    bVal = b.address ? b.address.city : '';
                    break;
                case 'status':
                    aVal = a.status || '';
                    bVal = b.status || '';
                    break;
                case 'created_at':
                    aVal = a.created_at ? new Date(a.created_at).getTime() : 0;
                    bVal = b.created_at ? new Date(b.created_at).getTime() : 0;
                    break;
                default:
                    return 0;
            }

            if (aVal < bVal) return this.sortDirection === 'asc' ? -1 : 1;
            if (aVal > bVal) return this.sortDirection === 'asc' ? 1 : -1;
            return 0;
        });
    }

    sort(column: string) {
        if (this.sortBy === column) {
            this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortBy = column;
            this.sortDirection = 'asc';
        }
    }

    getSortIcon(column: string) {
        if (this.sortBy !== column) return 'unfold_more';
        return this.sortDirection === 'asc' ? 'expand_less' : 'expand_more';
    }

    getCustomerStatusColor(
        status: 'in_progress' | 'standby' | 'archived' | 'processed'
    ) {
        if (status in customerStatusColors) {
            return customerStatusColors[status];
        }
        return `rgba(var(--vs-primary), 1)`;
    }

    get customerStatus() {
        return Object.entries(customerStatusMini).map(([key, value]) => ({
            text: value,
            value: key,
        }));
    }

    getCity(customer: Customer) {
        return customer.address ? `${customer.address.city} (${customer.address.postal_code})` : '-';
    }

    getAddress(customer: Customer) {
        return customer.address ? customer.address.street || '-' : '-';
    }

    getPostalCode(customer: Customer) {
        return customer.address ? customer.address.postal_code || '-' : '-';
    }

 


        // Delete a prospect
            deleteProspect(customer: Customer) {
                this.customerToDelete = customer;
                this.showDeleteConfirm = true;
            }

            deleteBulkProspects() {
                this.showBulkDeleteConfirm = true;
            }

            async confirmBulkDelete() {
                const $vs = (this as any).$vs;
                try {
                    await Promise.all(this.selectedCustomers.map((id: number) => archiveCustomerPrescriber(id)));
                    this.customers = this.customers.filter(c => !this.selectedCustomers.includes(c.id as number));
                    this.selectedCustomers = [];
                    $vs.notify({
                        color: 'success',
                        position: 'top-right',
                        title: 'Succes',
                        text: 'Les prospects selectionnes ont ete supprimes avec succes',
                    });
                } catch (error) {
                    $vs.notify({
                        color: 'danger',
                        position: 'top-right',
                        title: 'Erreur',
                        text: 'Erreur lors de la suppression des prospects',
                    });
                }
                this.showBulkDeleteConfirm = false;
            }

            cancelBulkDelete() {
                this.showBulkDeleteConfirm = false;
            }

       

    async confirmDelete() {
            if (!this.customerToDelete || !this.customerToDelete.id) return;
            
            const $vs = (this as any).$vs;
            const customerId = this.customerToDelete.id;
            
            try {
                await archiveCustomerPrescriber(customerId);
                
                // Remove from local array
                const index = this.customers.findIndex(c => c.id === customerId);
                if (index !== -1) {
                    this.customers.splice(index, 1);
                }
                
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Succès',
                    text: 'Le prospect a été supprimé avec succès',
                });
                
                this.showDeleteConfirm = false;
                this.customerToDelete = null;
            } catch (error) {
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: 'Erreur lors de la suppression du prospect',
                });
            }
}

    cancelDelete() {
        this.showDeleteConfirm = false;
        this.customerToDelete = null;
    }



}
